import { useTranslation } from "react-i18next";
import { TopNav } from "../../components/nav/TopNav";
import { TaggedExamples } from "../HomePage/TaggedExamples";
import { LandingPageForm } from "../../components/common/LandingPageForm";
import { ThreeStepGuide } from "../../components/common/ThreeStepGuide";
import { HeroCarousel } from "../../components/common/HeroCarousel";
import "./RegionLandingPage.less";

type RegionLandingPageProps = {
  regionKey: "westCoast" | "eastCoast";
  tag: string;
  heroFolder?: string;
};

export function RegionLandingPage({ regionKey, tag, heroFolder }: RegionLandingPageProps) {
  const { t } = useTranslation("landing");
  const slug = tag.replace(/ /g, "-");

  return (
    <div className={`lp-region lp-${slug}`} data-testid={`lp-${slug}`}>
      <section className="lp-hero" data-testid="lp-hero">
        <HeroCarousel folder={heroFolder ?? slug} />
        <div className="lp-hero__scrim" />
        <TopNav overlay />
        <div className="lp-hero-inner">
          <div className="lp-hero__content">
            <h1
              className="lp-hero__title"
              dangerouslySetInnerHTML={{ __html: t(`regions.${regionKey}.headline`) }}
            />
            <p className="lp-hero__sub">{t(`regions.${regionKey}.sub`)}</p>
          </div>
        </div>
      </section>

      <div className="lp-form-anchor">
        <LandingPageForm region={regionKey} />
      </div>

      <section className="lp-examples">
        <p className="lp-examples__eyebrow">{t("examplesEyebrow")}</p>
        <h2 className="lp-examples__headline">{t(`regions.${regionKey}.examplesHeadline`)}</h2>
        <TaggedExamples tag={tag} />
      </section>

      <ThreeStepGuide />
    </div>
  );
}
